import { createSelector } from '@reduxjs/toolkit';
import { Inconsistency5SFilesBucket, Inconsistency5SFilesState } from '../../types/inconsistency5SFiles';

const EMPTY_BUCKET: Inconsistency5SFilesBucket = { files: [], loading: false, error: null };

const selectSlice = (state: any): Inconsistency5SFilesState =>
  state.myTasksStrapi.inconsistency5SFiles;

export const selectInconsistencyFiles = (inconsistencyId: number) =>
  createSelector([selectSlice], (slice) => (slice[inconsistencyId] || EMPTY_BUCKET).files);

export const selectInconsistencyFilesLoading = (inconsistencyId: number) =>
  createSelector([selectSlice], (slice) => (slice[inconsistencyId] || EMPTY_BUCKET).loading);

export const selectInconsistencyFilesError = (inconsistencyId: number) =>
  createSelector([selectSlice], (slice) => (slice[inconsistencyId] || EMPTY_BUCKET).error);
